import GenealogyLayout from '@/core/layout/genealogy/genealogy.layout'

const GenealogyPage = () => {
    return <GenealogyLayout />
}

export default GenealogyPage
